import NImage from '@base/Image';

import {
  ClassTitle,
  FormHeadingWrapper,
  FormSubHeading,
  StyledP2,
  StyledSpan,
  SubHeading
} from './styles';

const FormHeading = ({ rollNumber }) => {
  return (
    <>
      <FormHeadingWrapper>
        <ClassTitle>Welcome to Unacademy!</ClassTitle>
        <NImage
          src="offline-centres/postpayment/form-celebration.svg"
          alt="checkmark"
          height={40}
          width={40}
        />
      </FormHeadingWrapper>
      <FormSubHeading>
        {rollNumber && (
          <SubHeading>
            <NImage
              src="offline-centres/postpayment/light-checkmark.svg"
              alt="checkmark"
              height={20}
              width={20}
            />
            <StyledP2>
              Your roll number is <StyledSpan>{rollNumber}</StyledSpan>
            </StyledP2>
          </SubHeading>
        )}
        <SubHeading>
          <NImage
            src="offline-centres/postpayment/light-checkmark.svg"
            alt="checkmark"
            height={20}
            width={20}
          />
          <StyledP2>We need few more details for your ID card</StyledP2>
        </SubHeading>
      </FormSubHeading>
    </>
  );
};

export default FormHeading;
